import React from 'react';
import { Button, Divider, Stack, Typography, useTheme } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from 'recharts';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// class CartesianGridNoDashVertical extends CartesianGrid {
//     renderVertical(verticalPoints) {
//         const element = super.renderVertical(verticalPoints);
//         const lines = element.props.children.map((el) =>
//             React.cloneElement(el, { strokeDasharray: "0" })
//         );
//         return React.cloneElement(element, [], lines);
//     }
// }
export default function GraphDetails({graphData, transactionData}) {
    const {t} = useTranslation()
    const theme = useTheme();
    const { user } = useSelector((state) => state.auth);

    const convertedData = graphData?.graph?.map(item => {
        const convertedDate = moment(new Date(item?.date)).format("DD/MM");
        return { name: convertedDate, price: item.price };
      });

    
    return (
        <Stack className='!w-[420px]' style={{minHeight: "300px",}}>
            <Stack className='!m-[10px]'>
                <Typography style={{fontSize:"14px",}}  className="ff-Roboto fw-regular !mb-[8px]">
                    {t('Cost per tonne of emissions produced in €')}
                    {/* (in $ or €) */}
                </Typography>
                <Stack direction="row" className='!flex !justify-end !items-start'>
                    {/* <Button className='!bg-[#FFCC00] !text-black !rounded-full !w-[100px] !h-[30px] !text-[10px]'>
                        USD ($/ton)
                    </Button> */}
                    <Button className='!ml-[10px] !bg-[#FFCC00] !text-black !rounded-full !w-[100px] !h-[30px] !text-[10px]'>
                        Europe (€/ton)
                    </Button>
                </Stack>
            </Stack>
            <Stack className='!ml-[10px]'>

                <LineChart
                    className='bg-[#14285A1A]'
                    width={400}
                    height={220}
                    data={convertedData}
                    margin={{
                        top: 20,
                        bottom: 0,
                        left: -20,
                        right: 14
                    }}
                    
                >
                    <CartesianGrid strokeDasharray="4 4" />
                    <XAxis padding={{left: 0, right: 0}} tickMargin={8}   dataKey="name" angle={320} tick={{ fill: 'rgb(0,0,0,0.3)', fontSize: '9px'}}   stroke='#14285A1A'   width={100} type='category' />
                    <YAxis tick={{ fill: 'rgb(0,0,0,0.3)', fontSize: '12px' }} axisLine={false} stroke='#14285A1A' tickLine={{ stroke: '#14285A1A' }} />
                    <Tooltip />
                    <Line  type="monotone" dataKey="price" stroke="#FB9A99"  />
                </LineChart>
            </Stack>
            <Stack className='!m-[10px]'>
                {user?.type !== 'trader' && transactionData?.transactionId && <Divider />}
            </Stack>
            {user?.type !== 'trader' && transactionData?.transactionId && <>
            <Stack className='!m-[10px]'>
                <Stack className='!w-[100%] !h-[60px] !bg-[#FFCC00] !rounded '>
                    <Typography className='!font-bold !text-[15px] !mt-[8px] !ml-[10px] !mr-[8px]'>
                        Transaction Details
                    </Typography>
                    <Typography className='!font-normal !text-[10px] !mt-[4px] !ml-[10px] !mr-[8px]'>
                    {moment(transactionData?.tradeTimeStamp).toString() || '-'}
                    </Typography>
                </Stack>
            </Stack>
            <Stack className='!m-[10px]'>
                <Stack direction='row' className='!w-[100%] !h-[100px] !bg-[#f3f4f7] !p-[15px] !rounded !justify-between !items-center'>
                    <Stack className='!m-[8px]'>
                        <Stack>
                            <Typography className='!font-normal !text-[10px]'>
                                Transaction ID
                            </Typography>
                            <Typography className='!font-bold !text-[15px]'>
                                {transactionData?.transactionId || '-'}
                            </Typography>
                        </Stack>
                        <Stack className='!mt-[8px]'>
                            <Typography className='!font-normal !text-[10px]'>
                                EUA allowance
                            </Typography>
                            <Typography className='!font-bold !text-[15px]'>
                               {transactionData?.euaAllowance || '-'}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack className='!m-[8px]'>
                        <Stack>
                            <Typography className='!font-normal !text-[10px]'>
                                Price Type
                            </Typography>
                            <Typography className='!font-bold !text-[15px]'>
                                {transactionData?.priceType || '-'}
                            </Typography>
                        </Stack>
                        <Stack className='!mt-[8px]'>
                            <Typography className='!font-normal !text-[10px]'>
                                EUA Price
                            </Typography>
                            <Typography className='!font-bold !text-[15px] !text-[#00A632]'>
                                ${transactionData?.euaPrice || '-'}/ton
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack></>}
            
        </Stack>
    );
}
